import Vue from 'vue'
import store from '@/store'

export default function(dom, opts) {
	let options = {
		...opts
	};

	const buttons = [].slice.call(dom.querySelectorAll('button, input[type="submit"]'), 0);
	const inputs = [].slice.call(dom.querySelectorAll('input, textarea'), 0);

	let page = new Vue({
		store,
	})

	dom.addEventListener('submit', e => {
		inputs.forEach(input => {
			input.readOnly = true;
		});
		buttons.forEach(button => {
			button.disabled = true;
		});
		page.$store.dispatch('loader/setLoading', true);
	});
}